import RouteError from '@/components/ui/route-error';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import Hero from '@/features/landing/components/hero';
import FeaturesSection from '@/features/landing/components/features-section';
import HowItWorks from '@/features/landing/components/how-it-works';
import { APP_PATHS } from '@/config/routes/app-paths';
import { useAppStore } from '@/stores/app-store';
import { ensureValidPath } from '@/utils/validate-path';
import { AUTH_TABS } from '@/features/landing/types/auth-card';

const landingSearchSchema = z.object({
  tab: z.enum(AUTH_TABS).optional(),
  partner: z.string().optional(),
});

const LandingPage = () => {
  return (
    <>
      <Hero />
      <FeaturesSection />
      <HowItWorks />
    </>
  );
};

export const Route = createFileRoute('/')({
  beforeLoad: () => {
    const authed = useAppStore.getState().isAuthenticated;
    if (authed) {
      throw redirect({ to: ensureValidPath(APP_PATHS.overview) });
    }
  },
  component: LandingPage,
  errorComponent: RouteError,
  validateSearch: (search) => landingSearchSchema.parse(search),
});
